export default __webpack_public_path__ + "static/media/bg14.04f264a9.jpg";